import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const BASE_KEY = "apps";
const FILTER_DESCRIPTION_QUERY_KEY = "filter-description";

export const appsQueryKeys = {
    filterDescription: () => [BASE_KEY, FILTER_DESCRIPTION_QUERY_KEY] as const,
} as const satisfies QueryKeyFactory;
